"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var i18next_1 = require("i18next");
var createStrings_1 = require("./createStrings");
function I18n(I18nProvider) {
    var i18nextInstance = i18next_1.default.createInstance();
    var Provider = I18nProvider(i18nextInstance);
    return {
        createStrings: createStrings_1.default,
        // abstraction leak so we can provide <Interpolate /> the
        // instance it needs to resolve translation + interpolation
        // Next step would be to expose a component which will internally
        // handle i18nextInstance
        i18nextInstance: i18nextInstance,
        initialize: Provider.initialize,
        addLanguages: Provider.addLanguages,
        t: Provider.translate,
        getCurrentLanguage: Provider.getCurrentLanguage,
        changeLanguage: Provider.changeLanguage,
    };
}
exports.default = I18n;
